export const FAIRS = '/fair';
export const FLOOR_PLAN = '/floor-plan';
export const FLOOR_PLAN_BASE = '/floor-plan-base';
